// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3Ppyp","footer":"ModalFilter_footer__2vjoy"};